type Environment = 'test' | 'prod' | 'production' | null;

class RuntimeConfigService {
  private environment: Environment = null;

  private readonly environmentUrls: Record<string, string> = {
    test: 'https://apik.carvanatech.com',
    prod: 'https://apik.carvana.io',
    production: 'https://apik.carvana.io',
  };

  public initialize(env?: string): void {
    if (!env) return;

    if (env === 'test' || env === 'prod' || env === 'production') {
      this.environment = env;
    } else {
      console.warn(`RuntimeConfigService: Invalid environment "${env}". Expected 'test', 'prod', or 'production'.`);
    }
  }

  public getApiBaseUrl(): string {
    if (this.environment && this.environmentUrls[this.environment]) {
      return this.environmentUrls[this.environment];
    }

    const fallbackUrl = process.env.CARVANA_API_HYDRA_BASE_URL;
    if (!fallbackUrl) {
      throw new Error(
        'RuntimeConfigService: No API base URL configured. Set CARVANA_API_HYDRA_BASE_URL or call initialize() with a valid environment.'
      );
    }
    return fallbackUrl;
  }

  public getEnvironment(): Environment {
    return this.environment;
  }

  public reset(): void {
    this.environment = null;
  }
}

export const runtimeConfig = new RuntimeConfigService();

export const getApiBaseUrl = (): string => runtimeConfig.getApiBaseUrl();
